export const CAPTION_TYPE = {
  TASK: 'TASK',
  SCORE: 'SCORE',
};

export default {CAPTION_TYPE};
